// removed by extract-text-webpack-plugin
module.exports = {"feature":"feature___1UymB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormMap/FeatureName.module.scss
// module id = 2105
// module chunks = 0